module.exports = __webpack_public_path__ + "static/media/agree@3x.4e40febf.png";